import {
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useColorMode,
  useColorModeValue,
} from '@chakra-ui/react';

import { LuMoon, LuSun, LuBell, LuGrip } from 'react-icons/lu';
import Applications from './Applications';

export function NotificationsNav() {
  const { colorMode, toggleColorMode } = useColorMode();
  const bg = useColorModeValue('white', 'gray.800');

  return (
    <HStack spacing={['6', '8']} pr={['4', '8']} py="2">
      <Icon
        cursor="pointer"
        as={colorMode === 'light' ? LuSun : LuMoon}
        fontSize={[18, 22]}
        onClick={toggleColorMode}
      />
      <Icon cursor="pointer" as={LuBell} fontSize={[18, 22]} />
      <Menu isLazy>
        <MenuButton>
          <Icon cursor="pointer" as={LuGrip} fontSize={[18, 22]} />
        </MenuButton>
        <MenuList
          overflowX="hidden"
          position="absolute"
          right="0"
          top="0"
          minW="350px"
        >
          <MenuItem _hover={{ bg }} cursor="default">
            <Applications />
          </MenuItem>
        </MenuList>
      </Menu>
    </HStack>
  );
}
